export const LayoutTypes = Object.freeze({
  blank: 'blank',
  basic: 'basic',
  menu: 'menu',
})

export const MenuPositions = Object.freeze({
  left: 'LEFT',
  top: 'TOP',
})

export const MenuTypes = Object.freeze({
  comfortable: 'COMFORTABLE',
  compact: 'COMPACT',
})

export const ColorModes = Object.freeze({
  light: 'light',
  dark: 'dark',
})

export type MenuType = keyof typeof MenuTypes
export type LayoutType = keyof typeof LayoutTypes
export type MenuPositionsType = keyof typeof MenuPositions
